import React from 'react';
import styled from 'styled-components';
import Container from 'components/utils/Container';
import Highlights from './components/highlights/Highlights';
import FlightCarriers from './components/flightCarriers/FlightCarriers';
import { mediaQueries } from 'styles/utils/mediaQueries';
import { ReactComponent as Waves } from 'static/graphics/waves.svg';
import { ReactComponent as WavesSand } from 'static/graphics/waves-sand.svg';

function CheckmarksComponent({ showHighlights, showFlightCarriers, homeBoxesIntoView }) {
  return (
    <Root>
      <WavesTop>
        <WavesSand width={'100%'} height={'100%'} preserveAspectRatio='xMinYMin slice' />
      </WavesTop>
      <Container
        style={{ minHeight: '96px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
        fullWidth={true}
      >
        {showHighlights && <Highlights />}
        {homeBoxesIntoView && showFlightCarriers && <FlightCarriers />}
      </Container>
      <WavesBottom>
        <Waves width={'100%'} height={'100%'} preserveAspectRatio='xMinYMin slice' />
      </WavesBottom>
    </Root>
  );
}

export default CheckmarksComponent;

const Root = styled.div`
  position: relative;
  margin-top: 64px;
  padding-bottom: 96px;
  //TODO - Consider extending the theme of the website with this parameter (waves color)
  background-color: ${({ theme }) =>
    theme.colors.footer.waves ? theme.colors.footer.waves : theme.colors.primary.default};

  .icon-smallScreens {
    display: block;
    margin: 0 auto 16px;
    color: ${({ theme }) => theme.colors.secondary.default};

    ${mediaQueries.fromAndAbove.tablet`
      display: none;
    `}
  }

  .li-smallScreens {
    ${mediaQueries.fromAndAbove.tablet`
      display: none;
    `}
  }

  .ul-desktop {
    ${mediaQueries.fromAndBelow.desktop` display: none !important; `}
  }

  ul {
    height: 100%;
    ${mediaQueries.fromAndBelow.tablet` margin: 0 auto; `}

    li {
      svg {
        margin-right: 0.5rem;
        color: ${(props) => props.theme.colors.secondary.default};
        width: 18px;
        ${mediaQueries.fromAndBelow.tablet` display: none; `}
      }
      color: ${(props) => props.theme.colors.text.default};
      font-weight: 500;
      font-size: 20px;
      line-height: 40px;

      ${mediaQueries.fromAndBelow.desktop`
        font-size: 18px;
        line-height: 30px;
      `}

      ${mediaQueries.fromAndBelow.tablet` text-align: center; font-size: 20px; `}
    }
  }

  h2 {
    color: ${(props) => props.theme.colors.text.default};
    font-family: ${(props) => props.theme.fonts.displaySubtle};
    font-size: 32px;
    text-align: center;
    font-weight: normal;
    margin-bottom: 1rem;
  }
`;

const WavesTop = styled.div`
  position: absolute;
  bottom: 98%;
  width: 100vw;
  height: 100%;
  max-height: 200px;
  z-index: -1;

  svg {
    path {
      //TODO - Consider extending the theme of the website with this parameter (waves color)
      fill: ${({ theme }) => (theme.colors.footer.waves ? theme.colors.footer.waves : theme.colors.primary.default)};
    }
  }
`;

const WavesBottom = styled.div`
  position: absolute;
  bottom: -2px;
  width: 100vw;
  height: 100%;
  max-height: 200px;

  svg {
    path:nth-child(4) {
      fill: ${({ theme }) =>
        theme.colors.footer.background ? theme.colors.footer.background : theme.colors.secondary.default};
    }
  }
`;
